import { DownOutlined, RightOutlined, TeamOutlined } from '@ant-design/icons'
import { Avatar, Button, Dropdown, Space, Typography } from 'antd'
import { useMatches, useNavigate  } from 'react-router-dom'
import type { RouteHandle } from '../../routes/interface'
import { useAuth } from '@/auth/AuthContext'
import './index.scss'

export default function Header() {
    const matches = useMatches()    
    const navigate = useNavigate()
    const currentMatch = matches[matches.length - 1]
    const currentRouteMeta = currentMatch?.handle as RouteHandle | undefined
    const { identity, logout, switchOrganization } = useAuth()
    const organizations = identity?.organizations || []

    return (
        <div className="header">
            <div className='header-item flex flex-center'>
                米卡智能资管系统
                <RightOutlined style={{fontSize: 10,color: '#94a3b8',margin: '0 6px'}} /> 
                {currentRouteMeta?.parent && 
                <span className='header-item-key' onClick={() => currentRouteMeta?.key && navigate(currentRouteMeta?.key)}>{currentRouteMeta?.parent}
                    <RightOutlined style={{fontSize: 10,color: '#94a3b8',margin: '0 6px'}} />
                </span>}
                <span className='header-item-title'>{currentRouteMeta?.title || ''}</span>
            </div>
            <Dropdown
                menu={{
                    items: [
                        {
                            key: 'organization',
                            icon: <TeamOutlined />,
                            label: '企业与成员',
                            onClick: () => navigate('/organization'),
                        },
                        ...(organizations.length > 1 ? [{
                            type: 'group' as const,
                            label: '切换企业',
                            children: organizations.map((organization) => ({
                                key: `org-${organization.id}`,
                                label: organization.name,
                                disabled: organization.id === identity?.organization.id,
                                onClick: () => void switchOrganization(organization.id),
                            })),
                        }] : []),
                        { type: 'divider' as const },
                        {
                            key: 'logout',
                            label: '退出登录',
                            onClick: async () => {
                                await logout()
                                navigate('/login', { replace: true })
                            },
                        },
                    ],
                }}
            >
                <Button type="text" style={{ height: 52 }}>
                    <Space>
                        <Avatar size="small">{identity?.user.display_name?.slice(0, 1) || 'U'}</Avatar>
                        <span>
                            <Typography.Text style={{ color: '#fff' }}>
                                {identity?.organization.name}
                            </Typography.Text>
                            <Typography.Text type="secondary" style={{ marginLeft: 8 }}>
                                {identity?.organization.role}
                            </Typography.Text>
                        </span>
                        <DownOutlined />
                    </Space>
                </Button>
            </Dropdown>
        </div>
    )
}
